import React, { useEffect, useState } from 'react'

function FixtureGoals({fixture}) {

    const [goals, setGoals] = useState([])

    useEffect(() => {

        if (fixture) {
            if (fixture.events && fixture.events.length) {

                const goals = fixture.events.filter(event => {
                    return (event.type === "Goal")
                })
                setGoals(goals);
            }
        }

    }, [fixture])

    return (
        <div className="row" style={{fontSize: "0.7rem"}}>

            {goals?.map((goal, index) => {
                
                return (
                    <React.Fragment key={index}>
                        <div className="col-5 text-right">
                            {goal.team_id === fixture.homeTeam.team_id && (
                                <>
                                    {goal.player} {goal.elapsed}'
                                </>
                            )}
                        </div>
                        <div className="col-2 text-center">
                            {goal.detail === "Penalty" && "(str)"}
                            {goal.detail === "Own Goal" && <i className="far fa-futbol text-danger"></i>}
                            {goal.detail === "Normal Goal" && <i className="far fa-futbol text-primary"></i>}
                            {goal.detail === "Missed Penalty" && <i className="far fa-times-circle text-danger"></i>}
                        </div>
                        <div className="col-5">
                            {goal.team_id === fixture.awayTeam.team_id && (
                                <>
                                    {goal.player} {goal.elapsed}'
                                </>
                            )}
                        </div>
                    </React.Fragment>
                )
            })}

        </div>
    )

}
export default FixtureGoals